import { Injectable } from '@angular/core';
import { ProcessoRiferimento } from '../models/data.model';

@Injectable({
  providedIn: 'root'
})
export class LegalEntityService {

  private LIST_LEGAL_ENTITY_STANDARD: string[] = [
    "PdG Ebit Srl",
    "PdG Esaote SpA",
    "QA Esaote Europe BV",
    "QA Esaote SpA",
    "QA Proton BV"
  ];

  private LIST_PROCESSI_STANDARD: string[] = [
    "Management",
    "Document and Record",
    "Medical Affairs",
    "Design and Development",
    "Supply Chain",
    "Compliance",
    "Operation",
    "Service",
    "Preservation of product",
    "Monitoring and measurement equipment",
    "Resource",
    "Measure-analysis and improvement",
    "Sales and Marketing",
    "Information Technology"
  ]

  private LIST_LEGAL_ENTITY_COMPLIANCE: string[] = [
    "SPP Esaote Spa",
    "Compliance",
    "Legal Standards",
    "Finance"
  ];

  private LIST_PROCESSI_COMPLIANCE: string[] = [
    "Compliance",
    "Legal",
    "Legal x",
    "Sustainability",
    "GDPR",
    "Finance"
  ];

  constructor() { }

  isLegalEntityCompliance(legalEntity: string): boolean {
    return this.LIST_LEGAL_ENTITY_COMPLIANCE.find(legalEntityCompliance => legalEntityCompliance.toUpperCase() == legalEntity.toUpperCase()) ? true : false;
  }

  isProcessoCompliance(processo: ProcessoRiferimento): boolean {
    return this.LIST_PROCESSI_COMPLIANCE.find(processoCompliance => processoCompliance.toUpperCase() == processo.nome.toUpperCase()) ? true : false;
  }

}
